<template>
  <v-app :style="{background: this.$vuetify.theme.themes.light.background}">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card>
              <v-toolbar color="primary" flat>
                <v-toolbar-title class="white--text headline">原価管理システム ログイン</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-alert type="success" v-if="loading" dense>
                  <template v-slot:prepend>
                    <awesome-icon name="sync" scale="1" spin/>
                  </template>
                  {{this.message}}
                </v-alert>
                <v-alert type="error" v-if="status != 200" dense>{{this.message}}</v-alert>
                <v-form>
                  <v-text-field v-model="credentials.email" label="ログインID" name="login" prepend-icon="mdi-account" type="text" :disabled="loading"></v-text-field>
                  <v-text-field v-model="credentials.password" :type="showPassword ? 'text' : 'password'" id="password"
                  label="パスワード" name="password" prepend-icon="mdi-onepassword" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword" :disabled="loading"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="indigo" v-on="on" :to="{ name: 'InquiryEntry' }"><v-icon>mdi-help-circle-outline</v-icon></v-btn>
                  </template>
                  <span>ヘルプ</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.prevent="submit" :disabled="loading">
                  <v-icon>mdi-login-variant</v-icon>
                  ログイン
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import { UserStateActions } from "@/store/module/user-state";
  import AuthApi from "@/api/auth-api";
  import 'vue-awesome/icons'
  import AwesomeIcon from 'vue-awesome/components/Icon'

  export default {
    name: "Login",
    components: {
      AwesomeIcon
    },
    data: () => ({
      loading: false,
      showPassword: false,
      status: 200,
      message: null,
      credentials: {
        email: null,
        password: null
      }
    }),
    beforeCreate() {
      const currentToken = sessionStorage.getItem("asd-token");
      if (currentToken) {
        this.$store.dispatch(UserStateActions.setAuth, currentToken);
      }
    },
    created() {
      this.authApi = new AuthApi();
    },
    methods: {
      submit() {
        this.loading = true;
        this.message = "ログイン中です...";
        this.status = 200;
        const promise = this.authApi.login({
          email: this.credentials.email,
          password: this.credentials.password
        });
        promise.then((response) => {
          this.message = response.data.message;
          this.status = response.data.status;
          this.$store.dispatch(UserStateActions.setAuth, response.data.body.token);
          this.$store.dispatch(UserStateActions.setUser, {
            company_id: response.data.body.company_id,
            company_name: response.data.body.company_name,
            theme_no: response.data.body.theme_no,
            user_id: response.data.body.user_id,
            user_name: response.data.body.user_name,
            email: response.data.body.email,
            role_id: response.data.body.role_id,
            role_name: response.data.body.role_name,
            icon_name: response.data.body.icon_name,
            department_id: response.data.body.department_id,
            department_name: response.data.body.department_name,
            permission_name: response.data.body.permission_name,
            permission_config: response.data.body.permission_config,
            worker_break_hour_time: response.data.body.worker_break_hour_time,
            worker_break_minute_time: response.data.body.worker_break_minute_time
          });
          useAppInsights().setAuthenticatedUserContext(response.data.body.user_id);
          this.$router.push({ name: "Dashboard" });
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          this.message = error.response.data.message;
          this.status = error.response.data.status;
        }).finally(() => {
          this.loading = false;
        });
      }
    }
  };
</script>
